import { useLazyLoadQuery, readInlineData } from 'react-relay';
import { UnifiedProfileFragment$key } from 'graphql/__generated__/UnifiedProfileFragment.graphql';
import { UnifiedProfileQuery } from 'graphql/__generated__/UnifiedProfileQuery.graphql';
import { UNIFIED_PROFILE_FRAGMENT } from 'graphql/UnifiedProfileFragment';
import { UNIFIED_PROFILE_QUERY } from 'graphql/UnifiedProfileQuery';

const useIsProfileLinkedView = (internalId: string): boolean => {
  const unifiedProfile = useLazyLoadQuery<UnifiedProfileQuery>(
    UNIFIED_PROFILE_QUERY,
    { internalId },
    { fetchPolicy: 'store-or-network' },
  )?.unified?.unifiedProfile;

  let profileFragmentData;

  if (unifiedProfile && '__fragments' in unifiedProfile) {
    profileFragmentData = readInlineData<UnifiedProfileFragment$key>(
      UNIFIED_PROFILE_FRAGMENT,
      unifiedProfile,
    );
  }

  return profileFragmentData?.isLinkedView ?? false;
};

export default useIsProfileLinkedView;
